import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ZoomInIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35 32L25.1839 23.05M25.1839 23.05C27.8406 20.6277 29.3332 17.3423 29.3332 13.9166C29.3332 10.4909 27.8406 7.20551 25.1839 4.78318C22.5271 2.36085 18.9238 1 15.1666 1C11.4094 1 7.80605 2.36085 5.1493 4.78318C2.49255 7.20551 1 10.4909 1 13.9166C1 17.3423 2.49255 20.6277 5.1493 23.05C7.80605 25.4723 11.4094 26.8332 15.1666 26.8332C18.9238 26.8332 22.5271 25.4723 25.1839 23.05ZM15.1675 8.75101V19.0839M20.8339 13.9175H9.50111"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default ZoomInIcon;

ZoomInIcon.propTypes = customIconsPropTypes;
